import { send } from '../../../../../../../src/network';
import { type OrderDetail } from '../../../../../../../src/types/OrderDetail';
import { type PatchedOrderDetail } from '../../../../../../../src/types/PatchedOrderDetail';

export { type PatchedOrderDetail };

export interface UnskipOrderData {
  id: number;
  source: string;
}

type Params = {
  orderId: number;
  requestBody: PatchedOrderDetail;
};

export async function patchApiV2CustomersCustomerIdOrdersId({
  orderId,
  requestBody,
}: Params) {
  return await send<OrderDetail>({
    path: `/api/v2/customers/self/orders/${orderId}/`,
    method: 'PATCH',
    body: requestBody,
  });
}
